window.infoLineaPncSoplado = null;

if (window.location.pathname === "/soplado/periodo" || window.location.pathname === "/zona-trabajo") {
    
    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const modalEditarPnc = document.querySelector("#modalEditarPncSoplado");
    let idLineaProduccion = modalEditarPnc.querySelector("#idLineaPncSoplado").value;
    
    window.infoLineaPncSoplado = (idLineaProduccion) => {
        
        const url = `/api/soplado/pncSoplado?idLinea=${idLineaProduccion}`;

        const divModalEditarPnc = document.querySelector("#contEditarPncSoplado");
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {

                const data = result.result[0];
                
                const int = n => (Number(n) || 0);
                const dec = n => (Number(n) || '').toLocaleString('en-US',{minimumFractionDigits: 2,maximumFractionDigits: 2});
                const num = n => (Number(n) || '').toLocaleString('en-US');
                const txt = t => String(t ?? '').trim();      
                
                divModalEditarPnc.querySelectorAll('.inputRojo').forEach(input => input.classList.remove('inputRojo'));
                divModalEditarPnc.classList.toggle('canvaBloqueado', Number(data.estadoReporteSoplado) != 1);
                const contBtnModal = divModalEditarPnc.querySelector('.contBtnModal');
                if (contBtnModal) {
                    contBtnModal.classList.toggle('oculto', Number(data.estadoReporteSoplado) != 1);
                }
                const horaInicio = divModalEditarPnc.querySelector("#horaInicio");
                const horaFin = divModalEditarPnc.querySelector("#horaFin");
                const idDefecto = divModalEditarPnc.querySelector("#idCausaDefecto");
                const undsDefectuosas = divModalEditarPnc.querySelector("#undsDefectuosas");
                const idCausaContaminacion = divModalEditarPnc.querySelector("#idCausaContaminacion");
                const undsContaminadas = divModalEditarPnc.querySelector("#undsContaminadas");
                const undsCalidad = divModalEditarPnc.querySelector("#undsCalidad");
                const obs = divModalEditarPnc.querySelector("#obs");


                if (horaInicio || horaFin || idDefecto || undsDefectuosas || idCausaContaminacion || undsContaminadas || undsCalidad || obs) {
                    horaInicio.value = data.horaInicio;
                    horaFin.value = data.horaFin;
                    idDefecto.value = int(data.idCausaDefecto);
                    undsDefectuosas.value = num(data.undsDefectuosas);
                    idCausaContaminacion.value = int(data.idCausaContaminacion);
                    undsContaminadas.value = num(data.undsContaminadas);
                    undsCalidad.value = num(data.undsCalidad);
                    obs.textContent = txt(data.observaciones);
                }
            })
            .catch((error) => {
                console.error("Error en la solicitud:", error);
                alert("Ocurrio un error en info línea PNC soplado, contactar al administrador.");
                return;
            });
    };

    document.addEventListener('click', function (e) {
        const trAbrir = e.target.closest('.trSelectPncSoplado');
        if (trAbrir) {
            const idLineaProduccion = trAbrir.getAttribute('data-id');
            const modalEditarLineaPnc = document.querySelector('#formEditarPncSoplado');
            const modalReporteSoplado = document.querySelector('#formProduccionSoplado');
            let idPncSoplado = modalReporteSoplado.querySelector('#idReporteSoplado').value;

            if (!idLineaProduccion || !modalEditarLineaPnc || !modalReporteSoplado || isNaN(idLineaProduccion) || isNaN(idPncSoplado)) {
                alert("No se encontró el ID de la línea de producción o es inválido.");
                return;
            }else{
                let inputIdLineaProduccion = modalEditarLineaPnc.querySelector('#idLineaPncSoplado');
                let inputIdReporteSoplado = modalEditarLineaPnc.querySelector('#idEncabezadoReporteSoplado');

                if(inputIdLineaProduccion  || inputIdReporteSoplado){
                    inputIdLineaProduccion.value = idLineaProduccion;
                    inputIdReporteSoplado.value = idPncSoplado;
                    window.infoLineaPncSoplado(idLineaProduccion);
                }else{
                    alert("No se encontró el campo oculto para el ID del encabezado del reporte.");
                    return;
                }
            }
        }
    });
}